import React from "react"

import SubHeroSectionDesktop from "./SubHeroSectionDesktop"
import SubHeroSectionMobile from "./SubHeroSectionMobile"

const SubHeroSection = ({ section, practice, theme, highlightedField, viewMode = "", deviceType = "desktop" }) => {
  // If viewMode is explicitly set (from preview), use that to determine which component to show
  if (viewMode === "mobile") {
    return (
      <SubHeroSectionMobile section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
    )
  }

  if (viewMode === "desktop") {
    return (
      <SubHeroSectionDesktop section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
    )
  }

  // Use server-side device detection for public pages
  if (deviceType === "mobile") {
    return (
      <SubHeroSectionMobile section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
    )
  }

  // Default to desktop for desktop devices
  return (
    <SubHeroSectionDesktop section={section} practice={practice} theme={theme} highlightedField={highlightedField} />
  )
}

export default SubHeroSection
